import axios from 'axios';
import { config, DOMAIN_URL } from '../utils/config';

class ImageService {
    static config = {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS"
        }
    };

    static async fetchImageNames() {
        const data = await axios.get(`${DOMAIN_URL}${config.REACT_APP_API_IMG}`, this.config).then(response => {
            // console.log('files', response);
            return response.data.files
        });
        return data;
    }
}

export default ImageService;